import React from 'react';
import styled, {css} from 'styled-components';
import SVG, {Props as SVGProps} from 'react-inlinesvg';
import {transformSizePropToSize} from 'utils/common';
import {BaseIconContainer} from './styled';
import questionCircle from 'assets/icons/icon-question-circle.svg?no-inline';
import whiteArrowRight from 'assets/icons/arrowNext.svg?no-inline';
import trash from 'assets/icons/rubbish-bin.svg?no-inline';
import camera from 'assets/icons/camera.svg?no-inline';
import picture from 'assets/icons/picture-icon.svg?no-inline';
import close from 'assets/icons/close-icon.svg?no-inline';
import padlock from 'assets/icons/padlock.svg?no-inline';
import backArrow from 'assets/icons/back-arrow.svg?no-inline';
import arrowRightBlue from 'assets/icons/arrow-right-icon-blue.svg?no-inline';
import thunder from 'assets/icons/tunder_icon.svg?no-inline';
import editIcon from 'assets/icons/edit-icon.svg?no-inline';
import questionCircleBlue from 'assets/icons/question-icon.svg?no-inline';
import warningSecondary from 'assets/icons/warning-secondary.svg?no-inline';
import checkSecondary from 'assets/icons/check-secondary.svg?no-inline';
import creditCardBlue from 'assets/icons/credit-card-blue2.svg?no-inline';
import checkOutCalendar from 'assets/icons/check-out-calendar.svg?no-inline';
import checkInCalendar from 'assets/icons/check-in-calendar.svg?no-inline';
import multiGuest from 'assets/icons/multi-guest.svg?no-inline';
import backBlueArrow from 'assets/icons/back-blue-arrow.svg?no-inline';
import information from 'assets/icons/information.svg?no-inline';
import plus from 'assets/icons/plus-icon.svg?no-inline';
import languageIcon from 'assets/icons/language-icon.svg?no-inline';
import lockIcon from 'assets/icons/lock-icon.svg?no-inline';
import home from 'assets/icons/home.svg?no-inline';
import keySidebar from 'assets/icons/key-sidebar.svg?no-inline';
import languageSidebar from 'assets/icons/language-sidebar.svg?no-inline';
import locationSidebar from 'assets/icons/location-sidebar.svg?no-inline';
import lockSidebar from 'assets/icons/lock-sidebar.svg?no-inline';
import checkFill from 'assets/icons/check-fill.svg?no-inline';
import shoppingCart from 'assets/icons/shopping-cart.svg?no-inline';
import blackMenu from 'assets/icons/black-menu.svg?no-inline';
import closeBlack from 'assets/icons/close-black.svg?no-inline';
import informationGray from 'assets/icons/information-gray.svg?no-inline';
import threeDots from 'assets/icons/three-dots.svg?no-inline';
import remoteAccessBuilding from 'assets/icons/remote-access-building.svg?no-inline';
import remoteAccessApartment from 'assets/icons/remote-access-apartment.svg?no-inline';
import doubleArrow from 'assets/icons/double-arrow.svg?no-inline';
import warningError from 'assets/icons/warning-error.svg?no-inline';
import notFoundHouse from 'assets/img/not-found-house.svg?no-inline';
import iconRegister from 'assets/icons/empty-state.svg?no-inline';
import errorModalIcon from 'assets/icons/error.svg?no-inline';
import dots from 'assets/icons/dots.svg?no-inline';
import autoFill from 'assets/icons/new-auto-filled-icon.svg?no-inline';
import arrowLeft from 'assets/icons/arrow-left.svg?no-inline';
import questionMarkIcon from 'assets/icons/question-blue-circle.svg?no-inline';
import guestCircle from 'assets/icons/guest-circle.svg?no-inline';
import grayRightArrow from 'assets/icons/gray-right-arrow.svg?no-inline';
import keyCircle from 'assets/icons/key-circle.svg?no-inline';
import shareArrow from 'assets/icons/share-arrow.svg?no-inline';
import shoppingCartCircle from 'assets/icons/shopping-car-circle.svg?no-inline';
import arrowDates from 'assets/icons/arrow-dates.svg?no-inline';
import successCircle from 'assets/icons/success-circle.svg?no-inline';
import image from 'assets/icons/image.svg?no-inline';
import blueTickIcon from 'assets/icons/credit-card-blue-tick.svg?no-inline';
import redXIcon from 'assets/icons/credit-card-red-x.svg?no-inline';
import copyLink from 'assets/icons/copy-link.svg?no-inline';
import addItem from 'assets/icons/add-item.svg?no-inline';
import wifi from 'assets/icons/guidebooks/wifi-icon.svg?no-inline';
import accessibility from 'assets/icons/guidebooks/accessibility-icon.svg?no-inline';
import arrowLocation from 'assets/icons/guidebooks/arrow-location.svg?no-inline';
import bag from 'assets/icons/guidebooks/bag.svg?no-inline';
import guideBookMainIcon from 'assets/icons/guidebooks/guidebook-main-icon.svg?no-inline';
import guidebookIcon from 'assets/icons/guidebooks/guidebook-icon.svg?no-inline';
import elevator from 'assets/icons/guidebooks/elevator.svg?no-inline';
import noSmoking from 'assets/icons/guidebooks/no-smoking.svg?no-inline';
import gym from 'assets/icons/guidebooks/gym.svg?no-inline';
import garage from 'assets/icons/guidebooks/garage.svg?no-inline';
import checkedBadge from 'assets/icons/guidebooks/checked-badge.svg?no-inline';
import checkedBadgeTwo from 'assets/icons/guidebooks/checked-badge-two.svg?no-inline';
import greetHand from 'assets/icons/guidebooks/greet-hand.svg?no-inline';
import location from 'assets/icons/guidebooks/location.svg?no-inline';
import phone from 'assets/icons/guidebooks/phone.svg?no-inline';
import plane from 'assets/icons/guidebooks/plane.svg?no-inline';
import emptyStateCart from 'assets/img/empty-state-cart.svg?no-inline';
import emptyStateList from 'assets/img/empty-state-list.svg?no-inline';
import tag from 'assets/icons/tag.svg?no-inline';
import magnifierGray from 'assets/icons/magnifier-gray.svg?no-inline';
import arrow from 'assets/icons/arrow-down.svg?no-inline';
import unavailableBooks from 'assets/icons/unavailable-books.svg?no-inline';
import download from 'assets/icons/download-icon.svg?no-inline';
import shareDownload from 'assets/icons/share-download.svg?no-inline';
import deleteItemBox from 'assets/icons/delete_item_box.svg?no-inline';
import calendar from 'assets/icons/calendar.svg?no-inline';
import experiencesUnits from 'assets/icons/experiences-units.svg?no-inline';
import ticketCircle from 'assets/icons/ticket-circle.svg?no-inline';
import minus from 'assets/icons/minus.svg?no-inline';
import dotList from 'assets/icons/guidebooks/dot-list.svg?no-inline';
import openBook from 'assets/icons/guidebooks/open-book.svg?no-inline';
import map from 'assets/icons/guidebooks/map.svg?no-inline';
import checkList from 'assets/icons/guidebooks/check-list.svg?no-inline';
import layout from 'assets/icons/guidebooks/layout.svg?no-inline';
import aboutPeople from 'assets/icons/guidebooks/about-people.svg?no-inline';
import weather from 'assets/icons/guidebooks/weather.svg?no-inline';
import infoFilled from 'assets/icons/info-filled.svg?no-inline';
import sheet from 'assets/icons/guidebooks/sheet.svg?no-inline';
import attractions from 'assets/icons/guidebooks/attractions.svg?no-inline';
import apartments from 'assets/icons/guidebooks/apartments.svg?no-inline';
import restaurant from 'assets/icons/guidebooks/restaurant.svg?no-inline';
import acDual from 'assets/icons/guidebooks/ac-dual.svg?no-inline';
import airConditioner from 'assets/icons/guidebooks/air-conditioner.svg?no-inline';
import babyChangingRoom from 'assets/icons/guidebooks/baby-changing-room.svg?no-inline';
import bagTwo from 'assets/icons/guidebooks/bag-2.svg?no-inline';
import bed from 'assets/icons/guidebooks/bed.svg?no-inline';
import boardGames from 'assets/icons/guidebooks/board-games.svg?no-inline';
import bug from 'assets/icons/guidebooks/bug.svg?no-inline';
import chairWheels from 'assets/icons/guidebooks/chair-wheels.svg?no-inline';
import cleaning from 'assets/icons/guidebooks/cleaning.svg?no-inline';
import closetHanger from 'assets/icons/guidebooks/closet-hanger.svg?no-inline';
import coffeeMaker from 'assets/icons/guidebooks/coffee-maker.svg?no-inline';
import coffee from 'assets/icons/guidebooks/coffee.svg?no-inline';
import coldMode from 'assets/icons/guidebooks/cold-mode.svg?no-inline';
import crib from 'assets/icons/guidebooks/crib.svg?no-inline';
import fan from 'assets/icons/guidebooks/fan.svg?no-inline';
import fireplace from 'assets/icons/guidebooks/fireplace.svg?no-inline';
import fridge from 'assets/icons/guidebooks/fridge.svg?no-inline';
import hairDryer from 'assets/icons/guidebooks/hair-dryer.svg?no-inline';
import health from 'assets/icons/guidebooks/health.svg?no-inline';
import heat from 'assets/icons/guidebooks/heat.svg?no-inline';
import homeStorage from 'assets/icons/guidebooks/home-storage.svg?no-inline';
import iron from 'assets/icons/guidebooks/iron.svg?no-inline';
import kettle from 'assets/icons/guidebooks/kettle.svg?no-inline';
import kingBed from 'assets/icons/guidebooks/king-bed.svg?no-inline';
import laundryMachine from 'assets/icons/guidebooks/laundry-machine.svg?no-inline';
import luggageTwo from 'assets/icons/guidebooks/luggage-2.svg?no-inline';
import luggage from 'assets/icons/guidebooks/luggage.svg?no-inline';
import metro from 'assets/icons/guidebooks/metro.svg?no-inline';
import microwave from 'assets/icons/guidebooks/microwave.svg?no-inline';
import microwaveTwo from 'assets/icons/guidebooks/microwave-2.svg?no-inline';
import outdoorGrill from 'assets/icons/guidebooks/outdoor-grill.svg?no-inline';
import oven from 'assets/icons/guidebooks/oven.svg?no-inline';
import petFriendly from 'assets/icons/guidebooks/pet-friendly.svg?no-inline';
import pool from 'assets/icons/guidebooks/pool.svg?no-inline';
import roomService from 'assets/icons/guidebooks/room-service.svg?no-inline';
import securityCamera from 'assets/icons/guidebooks/security-camera.svg?no-inline';
import securityPerson from 'assets/icons/guidebooks/security-person.svg?no-inline';
import security from 'assets/icons/guidebooks/security.svg?no-inline';
import shopping from 'assets/icons/guidebooks/shopping.svg?no-inline';
import shower from 'assets/icons/guidebooks/shower.svg?no-inline';
import sofa from 'assets/icons/guidebooks/sofa.svg?no-inline';
import spa from 'assets/icons/guidebooks/spa.svg?no-inline';
import stockpot from 'assets/icons/guidebooks/stockpot.svg?no-inline';
import train from 'assets/icons/guidebooks/train.svg?no-inline';
import tv from 'assets/icons/guidebooks/tv.svg?no-inline';
import vacuum from 'assets/icons/guidebooks/vacuum.svg?no-inline';
import google from 'assets/icons/google.svg?no-inline';
import apple from 'assets/icons/apple.svg?no-inline';
import noLogin from 'assets/icons/no-login.svg?no-inline';
import guestRegistration from 'assets/icons/guest-registration.svg?no-inline';
import logout from 'assets/icons/logout.svg?no-inline';
import carCircle from 'assets/icons/car-circle.svg?no-inline';
import addGuestTwo from 'assets/icons/add-guest-2.svg?no-inline';
import planeDetach from 'assets/icons/plane-detach.svg?no-inline';

export type IconNames =
  | 'whiteArrowRight'
  | 'trash'
  | 'camera'
  | 'picture'
  | 'close'
  | 'padlock'
  | 'backArrow'
  | 'arrowRightBlue'
  | 'editIcon'
  | 'thunder'
  | 'questionCircleBlue'
  | 'warningSecondary'
  | 'checkSecondary'
  | 'creditCardBlue'
  | 'checkOutCalendar'
  | 'checkInCalendar'
  | 'multiGuest'
  | 'backBlueArrow'
  | 'plus'
  | 'information'
  | 'languageIcon'
  | 'lockIcon'
  | 'keySidebar'
  | 'languageSidebar'
  | 'locationSidebar'
  | 'lockSidebar'
  | 'checkFill'
  | 'shoppingCart'
  | 'blackMenu'
  | 'closeBlack'
  | 'informationGray'
  | 'threeDots'
  | 'notFoundHouse'
  | 'iconRegister'
  | 'errorModalIcon'
  | 'dots'
  | 'autoFill'
  | 'arrowLeft'
  | 'remoteAccessBuilding'
  | 'remoteAccessApartment'
  | 'doubleArrow'
  | 'warningError'
  | 'questionMarkIcon'
  | 'guestCircle'
  | 'grayRightArrow'
  | 'keyCircle'
  | 'shareArrow'
  | 'shoppingCartCircle'
  | 'arrowDates'
  | 'successCircle'
  | 'image'
  | 'blueTickIcon'
  | 'redXIcon'
  | 'copyLink'
  | 'addItem'
  | 'wifi'
  | 'accessibility'
  | 'elevator'
  | 'no-smoking'
  | 'gym'
  | 'garage'
  | 'checkedBadge'
  | 'checkedBadgeTwo'
  | 'greetHand'
  | 'home'
  | 'location'
  | 'phone'
  | 'plane'
  | 'questionCircle'
  | 'arrowLocation'
  | 'bag'
  | 'guideBookMainIcon'
  | 'guidebookIcon'
  | 'emptyStateCart'
  | 'emptyStateList'
  | 'tag'
  | 'magnifierGray'
  | 'arrow'
  | 'unavailable-books'
  | 'download'
  | 'shareDownload'
  | 'deleteItemBox'
  | 'calendar'
  | 'experiencesUnits'
  | 'ticketCircle'
  | 'minus'
  | 'dot-list'
  | 'open-book'
  | 'map'
  | 'check-list'
  | 'layout'
  | 'about-people'
  | 'weather'
  | 'info-filled'
  | 'sheet'
  | 'attractions'
  | 'apartments'
  | 'restaurant'
  | 'ac-dual'
  | 'air-conditioner'
  | 'baby-changing-room'
  | 'bed'
  | 'board-games'
  | 'bug'
  | 'chair-wheels'
  | 'cleaning'
  | 'closet-hanger'
  | 'coffee-maker'
  | 'coffee'
  | 'cold-mode'
  | 'crib'
  | 'fan'
  | 'fireplace'
  | 'fridge'
  | 'hair-dryer'
  | 'health'
  | 'heat'
  | 'home-storage'
  | 'iron'
  | 'kettle'
  | 'king-bed'
  | 'laundry-machine'
  | 'luggage'
  | 'metro'
  | 'microwave'
  | 'outdoor-grill'
  | 'oven'
  | 'pet-friendly'
  | 'pool'
  | 'room-service'
  | 'security-camera'
  | 'security-person'
  | 'security'
  | 'shopping'
  | 'shower'
  | 'sofa'
  | 'spa'
  | 'stockpot'
  | 'train'
  | 'tv'
  | 'vacuum'
  | 'microwave-two'
  | 'luggage-two'
  | 'bag-two'
  | 'google'
  | 'apple'
  | 'no-login'
  | 'guest-registration'
  | 'logout'
  | 'carCircle'
  | 'addGuestTwo'
  | 'plane-detach';

export type IconsHash = {
  [K in IconNames]: string;
};

const icons: IconsHash = {
  questionCircle,
  whiteArrowRight,
  trash,
  camera,
  picture,
  close,
  padlock,
  backArrow,
  arrowRightBlue,
  editIcon,
  thunder,
  questionCircleBlue,
  warningSecondary,
  checkSecondary,
  creditCardBlue,
  checkOutCalendar,
  checkInCalendar,
  multiGuest,
  backBlueArrow,
  information,
  plus,
  languageIcon,
  lockIcon,
  home,
  keySidebar,
  languageSidebar,
  locationSidebar,
  lockSidebar,
  checkFill,
  shoppingCart,
  blackMenu,
  closeBlack,
  informationGray,
  threeDots,
  remoteAccessBuilding,
  remoteAccessApartment,
  doubleArrow,
  warningError,
  notFoundHouse,
  iconRegister,
  errorModalIcon,
  dots,
  logout,
  autoFill,
  arrowLeft,
  questionMarkIcon,
  guestCircle,
  grayRightArrow,
  keyCircle,
  shareArrow,
  shoppingCartCircle,
  arrowDates,
  successCircle,
  image,
  blueTickIcon,
  redXIcon,
  copyLink,
  addItem,
  wifi,
  accessibility,
  elevator,
  'no-smoking': noSmoking,
  'guest-registration': guestRegistration,
  gym,
  garage,
  checkedBadge,
  checkedBadgeTwo,
  greetHand,
  location,
  phone,
  plane,
  arrowLocation,
  bag,
  guideBookMainIcon,
  guidebookIcon,
  emptyStateCart,
  emptyStateList,
  tag,
  magnifierGray,
  arrow,
  'unavailable-books': unavailableBooks,
  download,
  shareDownload,
  deleteItemBox,
  calendar,
  experiencesUnits,
  ticketCircle,
  minus,
  'dot-list': dotList,
  'open-book': openBook,
  map,
  'check-list': checkList,
  layout,
  'about-people': aboutPeople,
  weather,
  'info-filled': infoFilled,
  sheet,
  attractions,
  apartments,
  restaurant,
  'ac-dual': acDual,
  'air-conditioner': airConditioner,
  'baby-changing-room': babyChangingRoom,
  bed,
  'board-games': boardGames,
  bug,
  'chair-wheels': chairWheels,
  cleaning,
  'closet-hanger': closetHanger,
  'coffee-maker': coffeeMaker,
  coffee,
  'cold-mode': coldMode,
  crib,
  fan,
  fireplace,
  fridge,
  'hair-dryer': hairDryer,
  health,
  heat,
  'home-storage': homeStorage,
  iron,
  kettle,
  'king-bed': kingBed,
  'laundry-machine': laundryMachine,
  'luggage-two': luggageTwo,
  luggage,
  metro,
  microwave,
  'microwave-two': microwaveTwo,
  'outdoor-grill': outdoorGrill,
  oven,
  'pet-friendly': petFriendly,
  pool,
  'room-service': roomService,
  'security-camera': securityCamera,
  'security-person': securityPerson,
  security,
  shopping,
  shower,
  sofa,
  spa,
  stockpot,
  train,
  tv,
  vacuum,
  'bag-two': bagTwo,
  google,
  apple,
  'no-login': noLogin,
  carCircle,
  addGuestTwo,
  'plane-detach': planeDetach,
};

export type IconProps = {
  name: IconNames;
  title?: string;
  className?: string;
  containerClassName?: string;
  size?: string | number;
  color?: string;
  custom?: boolean;
  $transparentSvg?: boolean;
  'aria-hidden'?: string;
} & React.HTMLAttributes<SVGElement> &
  React.HTMLAttributes<SVGProps>;

const StyledSVGIcon = styled(SVG)<{
  src: string;
  color?: string;
  size?: string | number;
  $custom?: string;
  $transparentSvg?: boolean;
  alt?: string;
}>`
  width: ${props => transformSizePropToSize(props.size) || '24px'};
  height: ${props => transformSizePropToSize(props.size) || '24px'};
  fill: ${props => (props.$transparentSvg ? 'transparent' : props.color || 'none')};
  color: ${props => props.color || 'none'};

  ${props => {
    if (props.color && props.color !== 'transparent') {
      return css`
        &:not(.chekin-empty-state__icon):not(.guest-register-view__icon-register):not(
            .error-view__icon
          ):not(.autofill-modal-sheet__icon) {
          path {
            fill: ${props.color};
          }
        }
      `;
    }
  }}

  ${props => {
    return props.$custom
      ? css`
          --icon-color: ${props.color || props.theme.colors.branding.icons};

          .system-path {
            fill: ${props.color || props.theme.colors.branding.icons};
          }
          #path-group {
            path,
            rect {
              fill: ${props.color || props.theme.colors.branding.icons};
            }
          }
          // styles for No register Guest svg AND 3 dots menu icon svg
          #empty-state-register-guest-linear-1,
          #empty-state-register-guest-linear-2,
          #sigle-dot-icon-linear-1,
          #sigle-dot-icon-linear-2,
          #sigle-dot-icon-linear-3,
          .auto-fill-icon-linear,
          .linear-svg-group {
            .stop-one {
              stop-color: ${props.color || props.theme.colors.branding.icons};
            }

            .stop-two {
              stop-color: ${props.color || props.theme.colors.branding.icons};
              opacity: 0.3;
            }
          }
          // end styles for No register Guest svg
          // styles for Error modal svg
          .primary-svg-color {
            fill: ${props.color || props.theme.colors.branding.icons};
            stroke: ${props.color || props.theme.colors.branding.icons};
            opacity: 0.3;
          }
          .secondary-svg-color {
            fill: ${props.color || props.theme.colors.branding.icons};
            stroke: ${props.color || props.theme.colors.branding.icons};
          }
          //end styles for Error modal svg

          .vector_1 {
            stroke: #dcdcdc;
            fill: none;
          }
          .vector_2 {
            stroke: #dcdcdc;
            fill: none;
          }

          .circle-background {
            fill: ${props.theme.colors.branding.backgroundSecondary};
          }
        `
      : css`
          .system-path,
          path {
            fill: ${props.color || props.theme.colors.branding.icons};
          }
        `;
  }}
`;

const CustomIcon = (props: IconProps) => {
  return (
    <BaseIconContainer
      size={props.size}
      className={`custom-icon ${props.containerClassName}`}
    >
      <StyledSVGIcon
        src={icons[props.name]}
        size={props.size}
        width={props.size}
        height={props.size}
        title={props.title || props.name}
        color={props.color || 'transparent'}
        className={'custom-icon__icon ' + props.className}
        $custom={props.custom ? 'true' : 'false'}
        $transparentSvg={props.$transparentSvg}
        aria-hidden={props['aria-hidden']}
      />
    </BaseIconContainer>
  );
};

export {CustomIcon};
